// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// modules
import * as R from 'ramda'
import { merge, Subject } from 'rxjs'
import { buffer, delay, filter, publish, tap } from 'rxjs/operators'
import { createWebSocketManager, IM_MAIN_SOCKET_ID } from '@weblite/ws-client'
import { LocalFind } from '@weblite/persist'
import {
  IAction,
  RequestAction,
  ResponseAction,
} from '@weblite/ts-action/types'
// actions
import { DATA_USER_CONNECT } from '@weblite/action/gateway'
import { DATA_AUTH_SIGNOUT } from '@weblite/action/auth'
import { EVENT_FORCE_UPDATE } from '@weblite/ts-action/gateway'
import hostConf from '$config/frontend'
// views
import { connectionStatusView } from '$comp/main/root.reducer'
import { serverSub } from '$func/subscription'
import { getAuthToken } from '$logic/auth'
// setup
import { features } from '$setup/features'
import onDisconnection from '$hooks/after/disconnection'
import onConnection from '$hooks/after/connection'
import { VERSION } from '$setup/version'
import { deviceId } from '$logic/analytics'

// const
const wsInitiator = () => {
  const compression = LocalFind('ws:compression')

  let url = `${hostConf.WS_HOST}/${getAuthToken()}?version=${VERSION}`
  if (compression !== false) {
    url += `&compress=${compression || 'zlib'}`
  }
  url += `&features=${[...features].join(',')}`
  url += `&meta=${deviceId}`

  return new window.WebSocket(url)
}

// ws hooks
const hooks = {
  onConnection,
  onDisconnection,
  shouldSend: () => connectionStatusView() === 'connected',
  willReconnect: (delayMs: number) => {
    // if (browserIsOnlineView()) {
    //   dispatchSetWillReconnectIn(Math.floor(delayMs / 1000))
    //   // setTimeout is to make sure this will happen after onDisconnection
    //   setTimeout(() => {
    //     dispatchSetConnectionStatus('will reconnect')
    //   }, 0)
    // }
  },
}

const decider$ = new Subject()
export const changeConnectionStatus = () => decider$.next()

const webSocketManager = createWebSocketManager(
  wsInitiator,
  hooks,
  true,
  IM_MAIN_SOCKET_ID,
)

export const { wsGet, wsGetNow, send: wsSend, sendNow } = webSocketManager
export const req = wsGet

export const { connect, terminateConnection } = (() => {
  const instantActions = new Set([
    DATA_USER_CONNECT,
    DATA_AUTH_SIGNOUT,
    EVENT_FORCE_UPDATE,
  ])

  let subscriber
  let wsCreatorData: ReturnType<typeof createWebSocketObservable> | undefined

  const createNewWebsocket = () => {
    wsCreatorData = webSocketManager.connect()
    const wsCreator$ = wsCreatorData.ws$.pipe(publish())

    const serverMessage$ = wsCreator$.pipe(
      filter(action => {
        if (!instantActions.has(action.type)) return true

        serverSub.publish(action)
        return false
      }),
      // TODO #verify https://rxjs.dev/6-to-7-change-summary#buffer
      buffer(
        merge(decider$, wsCreator$).pipe(
          filter(() => connectionStatusView() === 'connected'),
          delay(0),
        ),
      ),
      tap(R.forEach(action => serverSub.publish(action))),
    )

    subscriber = serverMessage$.subscribe()
    setTimeout(() => wsCreator$.connect(), 0)
  }

  return {
    connect: () => {
      if (wsCreatorData) wsCreatorData.reConnect()
      else createNewWebsocket()
    },
    terminateConnection: () => {
      if (!wsCreatorData) return
      wsCreatorData.terminateConnection()
      subscriber.unsubscribe()
      wsCreatorData = null
    },
  }
})()

export const send = (action: any, save?: boolean, retry?: number) =>
  wsSend(action, { save, retry })

export async function wsReq(...args: any) {
  if (req) {
    return req(...args)
  }
  return Promise.reject(Error("Web Socket hasn't initialized yet"))
}

export const wsRequest = async action => {
  const res = await wsGet(action)
  if (res.type !== action.type) serverSub.publish(res)
  return res
}

// TODO: will be merged by wsReq
// TODO: error are partial remove with function overloading
export function request<A extends IAction>(
  input: RequestAction<A['Req']>,
  sendOptions?: { save?: boolean; retry?: number },
): Promise<ResponseAction<A['Res']>> {
  return wsReq(input, sendOptions)
}

export function requestNow<A extends IAction>(
  input: RequestAction<A['Req']>,
): Promise<ResponseAction<A['Res']>> {
  return wsGetNow(input)
}
